module.exports = __webpack_public_path__ + "static/about_header-7600d538627148a318363ddf3e219e3b.png";